// This component has been autogenerated with 'generate:components' script

import styles from 'icons/Icon.module.css'
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

export const IconEdit = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: The <title> tag error is false positive error
		<svg
			xmlns='http://www.w3.org/2000/svg'
			xmlSpace='preserve'
			viewBox='0 0 24 24'
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='edit'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path d='M21.465.002c-.65 0-1.298.255-1.793.75l-.425.424 3.588 3.587.424-.424a2.534 2.534 0 0 0 0-3.587 2.54 2.54 0 0 0-1.794-.75m-3.017 2.104a.53.53 0 0 0-.31.163L1.21 19.209a.53.53 0 0 0-.146.228L.02 23.35a.52.52 0 0 0 .636.636l3.914-1.044a.53.53 0 0 0 .228-.147L21.743 5.872a.524.524 0 1 0-.734-.75L4.162 21.964l-2.12-2.12L18.89 3.002a.522.522 0 0 0-.392-.896z' />
		</svg>
	)
}
